import axios from "axios";
import messagePopupManager from "../../util/messagePopupManager";

export default {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions:{
        importGroupReservationExcel(context, file){
            let formData = new FormData();
            formData.append("file", file);
            return axios.post(context.getters.getServiceUrl + "/admin-api/group-reservation/import-excel", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": "Bearer " + context.getters.getToken.token
                }
            }).then((response)=>{
                return response.data;
            })
        },
        createGroupReservation(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/group-reservation/create", request,{headers, timeout:0})
                .then(response => {
                    return response.data;
                })

        }
    }
}